import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface TsoNotificationResource extends ng.resource.IResourceClass<
    ng.resource.IResource<TsoNotificationDto>
> {
    queryUnprocessed: ng.resource.IResourceArrayMethod<
        ng.resource.IResource<TsoNotificationDto>
    >;
    queryAllForTso: ng.resource.IResourceArrayMethod<
        ng.resource.IResource<TsoNotificationDto>
    >;
    markAsProcessed: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoNotificationDto>
    >;
}

function tsoNotificationResource(
    $resource: ng.resource.IResourceService
): TsoNotificationResource {
    return <TsoNotificationResource>$resource(
        config.monolithApi + '/tso-notification',
        {},
        {
            query: {
                method: 'GET',
                url: config.monolithApi + '/tso-notification/',
                isArray: true
            },
            queryUnprocessed: {
                method: 'GET',
                url: config.monolithApi + '/tso-notification/unprocessed',
                isArray: true
            },
            queryUnprocessedSince: {
                method: 'GET',
                url: config.monolithApi + '/tso-notification/unprocessed',
                isArray: true,
                params: {
                    sinceDate: '@sinceDate'
                }
            },
            queryAllForTso: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/tso-notification/all-notifications-for-tso-since-date',
                isArray: true,
                params: {
                    sinceDate: '@sinceDate'
                }
            },
            markAsProcessed: {
                method: 'POST',
                url: config.monolithApi + '/tso-notification/mark-as-processed'
            }
        }
    );
}

angular
    .module('app')
    .factory('tsoNotificationResource', tsoNotificationResource);
